<template>
  <section class="pdf-item">
    <div id="cv" class="cv-layout">
      <div class="cv-left">
        <div
          class="foto-wrapper"
          v-if="fotoSrc"
        >
          <div class="foto-card">
            <img
              :src="fotoSrc"
              alt="Foto de perfil"
              class="foto-card-img"
              @error="handleImageError"
            />
          </div>
        </div>

        <div class="cv-block">
          <p class="titulo-cv">Sobre mi</p>
          <div class="texto-cv" v-html="datosPersona?.descripcion"></div>
        </div>

        <div class="cv-block contacto-block">
          <p class="titulo-cv">Contacto</p>
          <div class="texto-cv">
            <p>
              Telefono:
              <span class="texto-strong">{{
                formatPhoneNumber(datosPersona?.telefono)
              }}</span>
            </p>
            <p>
              Correo:
              <span class="texto-strong">{{
                datosPersona?.email_personal
              }}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="cv-right">
        <p class="texto-nombre">{{ datosPersona?.nombre }}</p>
        <div class="cv-divider"></div>

        <div class="cv-section">
          <p class="titulo-cv">Formacion</p>
          <div
            class="texto-elementos"
            v-for="(formacionPesona, i) in datosPersona?.formacion"
            :key="'formacion-' + i"
            v-if="
              formacionPesona?.TipoFormacion?.nombre === 'Formacion continua'
            "
          >
            {{ formacionPesona?.FormacionEducativa?.nombre }}<br />
            {{ formacionPesona?.nombre_institucion }} |
            {{ moment(formacionPesona?.fecha_inicio).format("YYYY") }} -
            {{
              formacionPesona?.estudia === true
                ? "Actualmente"
                : moment(formacionPesona?.fecha_fin).format("YYYY")
            }}
          </div>
        </div>

        <div class="cv-section">
          <p class="titulo-cv">Experiencia Laboral</p>
          <div
            class="texto-elementos"
            v-for="(experiaPersona, i) in datosPersona?.experiencia"
            :key="'experiencia-' + i"
          >
            {{ experiaPersona?.puesto }} - {{ experiaPersona?.lugar_trabajo
            }}<br />
            {{ moment(experiaPersona?.fecha_inicio).format("YYYY") }} -
            {{
              experiaPersona?.trabaja === true
                ? "Actualmente"
                : moment(experiaPersona?.fecha_fin, "YYYY").format("YYYY")
            }}
          </div>
        </div>

        <div class="cv-section">
          <p class="titulo-cv">Certificados y Diplomas</p>
          <div
            class="texto-elementos"
            v-for="(formacionPesona, i) in datosPersona?.formacion"
            :key="'certificados-' + i"
            v-if="formacionPesona?.TipoFormacion?.nombre === 'Certificados'"
          >
            {{ formacionPesona?.otro_titulo }} |
            {{ formacionPesona?.nombre_institucion }}<br />
            {{ moment(formacionPesona?.fecha_inicio).format("YYYY") }} -
            {{
              formacionPesona?.estudia === true
                ? "Actualmente"
                : moment(formacionPesona?.fecha_fin).format("YYYY")
            }}
          </div>
        </div>

        <div class="cv-section">
          <p class="titulo-cv">Conocimientos</p>
          <ul class="list-reset texto-elementos">
            <li
              v-for="(ConocimientoPersona, i) in datosPersona?.conocimiento"
              :key="'conocimiento-' + i"
            >
              {{ ConocimientoPersona?.nombre_conocimiento }}
            </li>
          </ul>
        </div>

        <div class="cv-section">
          <p class="titulo-cv">Capacidades</p>
          <ul class="list-reset texto-elementos">
            <li
              v-for="(CapacidadPersona, i) in datosPersona?.capacidade"
              :key="'capacidad-' + i"
            >
              {{ CapacidadPersona?.nombre }}
            </li>
          </ul>
        </div>

        <div class="cv-section">
          <p class="titulo-cv">Otros aspectos</p>
          <ul class="list-reset texto-elementos">
            <li
              v-for="(item, i) in datosPersona?.otros_aspectos"
              :key="'aspecto-' + i"
            >
              {{ item?.nombre }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "curriculumDocument",
  data: () => ({
    datosPersona: null,
    defaultPhoto: require("@/assets/img/default_user.png")
  }),
  computed: {
    ...mapState({
      userInfo: "userInfo",
      token: "token"
    }),
    fotoSrc() {
      return this.getImage(this.datosPersona?.ruta_foto);
    }
  },
  methods: {
    async cargarDatos() {
      if (this.isTokenValido(this.token)) {
        try {
          if (this.userInfo?.id_persona) {
            const response = await this.services.datosPersona.getDatosCv(
              this.userInfo.id_persona
            );
            if (response.status === 200) {
              this.datosPersona = response.data;
            }
          }
        } catch (e) {
          console.error("Error en cargarDatos:", e);
        }
      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiro, debe de volver a iniciar sesion"
        });
        this.$router.replace({ name: "login" });
      }
    },
    getImage(path) {
      const candidate = path || this.userInfo?.ruta_foto;
      if (!candidate) {
        return this.defaultPhoto;
      }
      if (/^(data:|https?:\/\/|blob:)/i.test(candidate)) {
        return candidate;
      }
      const base = (process.env.VUE_APP_API_URL || "").replace(/\/$/, "");
      const normalized = String(candidate).replace(/^\//, "");
      return `${base}/${normalized}`;
    },
    handleImageError(event) {
      event.target.src = this.defaultPhoto;
    },
    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber) return "";
      if (phoneNumber.length === 9 && phoneNumber[4] === "-") {
        return phoneNumber;
      }
      return phoneNumber.slice(0, 4) + "-" + phoneNumber.slice(4);
    }
  },
  watch: {
    "userInfo.id_persona"(nuevoValor) {
      if (nuevoValor) {
        this.cargarDatos();
      }
    }
  },
  mounted() {
    if (this.userInfo?.id_persona) {
      this.cargarDatos();
    }
  }
};
</script>

<style lang="scss" scoped>
// @font-face {
//   font-family: "MuseoSans";
//   font-weight: normal;
//   font-style: normal;
//   font-display: swap;
//   src: local("MuseoSans"), url("/assets/fonts/MuseoSans.woff") format("woff");
// }

.pdf-item {
  font-family: "MuseoSans", sans-serif;
  width: 8.5in;
  height: 10.8in;
  max-height: 10.8in;
  margin: 0;
  padding: 0px;
  box-sizing: border-box;
  background: #fff;
}

#cv {
  display: grid;
  grid-template-columns: 5fr 7fr;
  gap: 16px;
  width: 100%;
  padding: 0.2in 0.25in;
  max-width: 1100px;
  margin: 0 auto;
}

.cv-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.foto-wrapper {
  width: 100%;
  max-width: 600px;
}

.foto-card {
  width: 100%;
  padding: 10px;
  aspect-ratio: 1 / 1;
  border-radius: 34px;
  background-color: #ececec;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.foto-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cv-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cv-right {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.cv-divider {
  width: 100%;
  height: 1px;
  background: #e0e0e0;
}

.titulo-cv {
  font-weight: 700;
  font-size: 24px;
  color: #1c1e4d;
  margin: 0;
}

.texto-cv {
  font-weight: 400;
  font-size: 16px;
  color: #616161;
  line-height: 1.5;
  margin: 0;
  text-align: justify;
}

.texto-cv p {
  margin: 0 0 8px 0;
}

.texto-nombre {
  font-size: 40px;
  font-weight: 700;
  color: #1c1e4d;
  margin: 0;
  line-height: 1.2;
}

.texto-elementos {
  font-weight: 600;
  font-size: 16px;
  color: #616161;
  line-height: 1.35;
}

.list-reset {
  padding-left: 0;
  margin: 0;
  list-style-position: inside;
  list-style-type: disc;
}

.list-reset li {
  margin-bottom: 6px;
}

.cv-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cv-section + .cv-section {
  margin-top: 6px;
}

.contacto-block .texto-cv {
  text-align: left;
}

.texto-strong {
  font-weight: 700;
}

@media (max-width: 900px) {
  #cv {
    grid-template-columns: 1fr;
  }

  .pdf-item {
    width: 100%;
    min-height: auto;
  }
}
</style>
